"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
export default function Expertise() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const tradeAreas = [{
    name: "Remodelling",
    summary: "Full room updates, kitchen refreshes, and bathroom renovations from demolition to finish trim.",
    param: "Remodelling"
  }, {
    name: "Carpentry & Drywall",
    summary: "Framing repairs, drywall patching, sheetrock installation, baseboards, and interior trim carpentry.",
    param: "Carpentry"
  }, {
    name: "Flooring Installation",
    summary: "Subfloor prep, vinyl flooring, laminate flooring, and hardwood flooring laid clean and flat.",
    param: "Hardwood Flooring"
  }, {
    name: "Tiling & Surfaces",
    summary: "Tile setting for bathroom walls, walk-in showers, kitchen backsplashes, and floor layouts.",
    param: "Tiling"
  }, {
    name: "Interior & Exterior Painting",
    summary: "Surface prep, drywall repair, caulking, and clean brush and roll coats for walls, ceilings, and trim.",
    param: "Painting"
  }, {
    name: "Plumbing Fixtures",
    summary: "Vanity installs, sink and faucet replacements, shower valve trim, and fixture hookups.",
    param: "Plumbing"
  }, {
    name: "Power Washing",
    summary: "High-pressure exterior washdowns for siding, decks, driveways, walkways, and patios.",
    param: "Power Washing"
  }, {
    name: "Snow Removal",
    summary: "Seasonal snow clearing for residential driveways and local commercial walkways in Prince William County.",
    param: "Snow Removal"
  }];
  return <section id="core-expertise" ref={sectionRef} className={`bg-card text-foreground py-14 md:py-20 lg:py-24 border-b border-border transition-opacity duration-300 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mb-10 md:mb-14">
          <h2 className="font-serif font-normal text-3xl md:text-4xl lg:text-5xl leading-[1.12] tracking-tight text-foreground border-l-4 border-primary pl-4 mb-4">
            Trade capabilities
          </h2>
          <p className="text-base text-muted-foreground leading-relaxed pl-5">
            Every service is handled using the company’s own equipment and hands-on site management, covering projects large and small in Dumfries and nearby towns.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
          {tradeAreas.map(trade => <div key={trade.name} className="border-t border-border pt-5 pb-2 flex flex-col justify-between">
              <div>
                <h3 className="font-serif font-normal text-xl text-foreground mb-2">
                  {trade.name}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed mb-4">
                  {trade.summary}
                </p>
              </div>
              <div>
                <Link to={`/BookAppointmentPage?service=${encodeURIComponent(trade.param)}`} className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-widest text-primary hover:underline">
                  <span>Book this service</span>
                  <ArrowRight className="size-3.5" />
                </Link>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}